import React from "react";
import NoData from "../assets/background/no-data.svg";
function InfoComponent({ message }) {
  return (
    <div className="info-container">
      <div>
        <img
          className="no-data-image"
          src={NoData}
          alt="../../public/logo192.png"
        ></img>
        <div className="info-paragh">
          <div dangerouslySetInnerHTML={{ __html: message || "" }}></div>
        </div>
      </div>
    </div>
  );
}

export default InfoComponent;
